module.exports = __webpack_public_path__ + "static/media/997846.8f90ff7e.png";